import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPartnerWithdrawals } from "../redux/WithdralSlice/withdrawalSlice";

const WithdrawalList = ({ userId }) => {
  const dispatch = useDispatch();
  const { withdrawals } = useSelector((state) => state.withdrawals);

  useEffect(() => {
    dispatch(fetchPartnerWithdrawals(userId));
  }, [dispatch, userId]);

  return (
    <div className="p-4 bg-white shadow-lg rounded-md">
      <h2 className="text-lg font-semibold mb-2">Withdrawal History</h2>
      <ul>
        {withdrawals.map((w) => (
          <li key={w._id} className="border-b p-2">
            <span className="font-medium">₹{w.amount}</span> -{" "}
            {w.status.toUpperCase()}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WithdrawalList;
